import * as React from 'react';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import useWindowSize from '../shared/useWindowSize';
import { isItTablet1280x800inLandscape } from '../../common/helpers';
import api from "../../store/api";
import { set } from 'lodash';
interface ConfirmshiftProps extends IAppPropsWithRoute {
};
const useStyles = makeStyles((theme) => ({
    root: {
       '& footer, .main-content': {
            background: "#fff",
            maxwidth: "900px",
            margin: "0 auto",
        },
        '& .main-content': {
            height: "100vh"
        },
        '& header img':{
            maxwidth: "100%",
            paddingleft: "30px",
        },
        '& header': {
            background:"#0048a4",
        },

        '& .body-content' :{
            minheight: "59vh",
            padding:"50px 40px",
            textalign: "left",
        },

        '& .main-content h1': {
            margintop:" 0px",
        },

        '& footer': {
            padding: "20px",
            fontsize: "12px",
            height: "10vh",
            color: "#8C8C8C",
            lineheight: "18px",
            paddingbottom:"0px",
            backgroundcolor: "#EBEBEB",
        },

        '& footer a': {
            color: "#8C8C8C",
        },
        '& @media (min-width: 768px)': {
            '& .body-content': {
                 minheight:"72vh",
            },
        },
        '& @media (min-width: 1280px)': {
            '& .body-content':{
                 minheight: "59vh",
            }
        }
    },
}));
function Confirmshift(props: ConfirmshiftProps): JSX.Element {
    const classes = useStyles();
    const requestId = props.match.params.requestId;
    const [initial, setinitial] =  React.useState(false);  
    const [driver, setdriver] =  React.useState(null);  
    React.useEffect(() => {    
        update();
    }, [])
    const update = async()=>{
        var res =await api.updateemail('id=' + requestId)  
        if(res.appId !==null)
        {
            setinitial(true);
            if(res.driver !==null)
            {
              setdriver(res.driver);
            }
            else{
            setdriver(null);
            }
        }
        else{
            console.log(res);
            setinitial(false);
        }
    }
    return (
       <div className={classes.root}>
        {initial ?
       <div className={"main-content"}>
        <header>
            <img src="https://hruyii.stripocdn.email/content/guids/CABINET_034fd1c8dc0faa8091a5a8eeb4c72b7e/images/97881601529007571.jpg"/>
        </header>
        <div className={"body-content"}>
            <h1>"Confirmed. You're working with {driver} today. Have a great shift<span>&#128515;</span>"</h1>
        </div>
        <footer>
            <p>You've received this email in response to activity on the SMA live platform. For help with using the SMA
                live platform, contact State Medical Assistance as <a
                    href="mailto:support@statemedicalassistance.com.au"
                    target="_blank">support@statemedicalassistance.com.au</a></p>
        </footer>
        </div>:
        <div><p>Please wait for Confirmation!!!</p></div>}
       </div>
    );
}

export default React.memo(withRouter(Confirmshift)) 
